import * as React from "react";
import { TextField, type ITextFieldStyles } from "@fluentui/react/lib/TextField";
import type { LtlFormCapabilities } from "@src/types/api";
import { ltlFieldInputId } from "@taskpane/utils/ltlValidationFocus";
import type { BolDetailsFormValues } from "./bolDetailsFormTypes";

type BlockProps = {
  form: BolDetailsFormValues;
  errors: Record<string, string>;
  caps: LtlFormCapabilities;
  onFieldBlur?: () => void;
  handleInputChange: (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => void;
  getTextFieldStyles: (fieldName: keyof BolDetailsFormValues) => Partial<ITextFieldStyles>;
};

export function BolDetailsAddressOriginBlock({
  form,
  errors,
  caps,
  onFieldBlur,
  handleInputChange,
  getTextFieldStyles,
}: BlockProps): React.ReactElement {
  return (
    <>
      <TextField
        label="Origin Address"
        name="originAddress"
        value={form.originAddress ?? ""}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        required={!!caps.requiresOriginAddress}
        id={ltlFieldInputId("originAddress")}
        styles={getTextFieldStyles("originAddress")}
        errorMessage={errors.originAddress}
      />
      <TextField
        label="Origin Address 2"
        name="originAddress2"
        value={form.originAddress2 ?? ""}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        id={ltlFieldInputId("originAddress2")}
        styles={getTextFieldStyles("originAddress2")}
        errorMessage={errors.originAddress2}
      />
      <TextField
        label="Dest. Address"
        name="destinationAddress"
        value={form.destinationAddress ?? ""}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        required={!!caps.requiresDestinationAddress}
        id={ltlFieldInputId("destinationAddress")}
        styles={getTextFieldStyles("destinationAddress")}
        errorMessage={errors.destinationAddress}
      />
      <TextField
        label="Dest. Address 2"
        name="destinationAddress2"
        value={form.destinationAddress2 ?? ""}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        id={ltlFieldInputId("destinationAddress2")}
        styles={getTextFieldStyles("destinationAddress2")}
        errorMessage={errors.destinationAddress2}
      />
    </>
  );
}
